'use client';

import { createContext } from 'react';

import type { DateTimeBlockRootContextInterface } from '../types/date-time-block-root.types';

export const DateTimeBlockRootContext = createContext({} as DateTimeBlockRootContextInterface);
